var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-collapse-item",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function(props) {
            return [
              _c("feather-icon", {
                staticClass: "mr-1 icon-header",
                attrs: {
                  icon: !!props.visible ? "ChevronUpIcon" : "ChevronDownIcon",
                  size: "18"
                }
              }),
              _c("span", { staticClass: "lead collapse-title" }, [
                _vm._v(
                  _vm._s(_vm.param.name) +
                    " (" +
                    _vm._s(_vm.levelDescription) +
                    ")"
                )
              ])
            ]
          }
        }
      ])
    },
    [
      _c(
        "template",
        { slot: "header-acction" },
        _vm._l(_vm.levelsVisibles, function(levelItem, index) {
          return _c(
            "span",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              key: "level-" + index,
              staticClass: "level-config",
              attrs: { title: levelItem.title },
              on: {
                click: function($event) {
                  return _vm.changeLevelView(levelItem.id)
                }
              }
            },
            [
              _c("b-avatar", {
                attrs: {
                  size: "25",
                  icon: levelItem.icon,
                  variant:
                    _vm.level === levelItem.id
                      ? "success"
                      : _vm.config["valor" + _vm.capitalize(levelItem.id)]
                      ? "info"
                      : "secondary"
                }
              })
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _vm._v(" Descripción: " + _vm._s(_vm.param.description) + " ")
        ]),
        _c("div", { staticClass: "col-md-6" }, [
          _vm._v(" Parametro Id: "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "cursor-pointer",
              class: { "text-success": _vm.wasCopied },
              attrs: {
                title: _vm.wasCopied
                  ? "Parametro Id copiado al portapapeldes"
                  : "Copiar Parametro Id"
              },
              on: {
                click: function($event) {
                  return _vm.copyToClipboard(_vm.param.parameter_id)
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.param.parameter_id) + " ")]
          )
        ]),
        _c("div", { staticClass: "col-md-6" }, [
          _vm._v(
            " Ultima Actualizacion: " + _vm._s(_vm.configurationDate) + " "
          )
        ])
      ]),
      _c("br"),
      _c("config-input-wrapper", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.init,
            expression: "init"
          }
        ],
        key: _vm.level,
        attrs: {
          "selected-user-id": _vm.selectedUserId,
          application: _vm.application,
          type: _vm.param.type,
          config: _vm.param.config,
          level: _vm.level,
          levels: _vm.levels,
          param: _vm.param.parameter_id,
          parameter: _vm.param,
          value: _vm.value
        },
        on: { saved: _vm.onSaveValue }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }